import React from "react";
import { KTextInput, KDialog } from "@kyburz/kdesign-system";
import useSetState from "../hooks/useSetState";
import DevicesTable from "./DevicesTable";

interface Props {
  name: string;
  company?: string;
  label?: string | undefined;
  value?: string;
  onChange: (v, v1) => void | any;
  placeholder?: string;
  helperText?: string;
  error?: boolean;
  errorText?: string;
  disabled?: boolean;
  style?: any;
  canRemoveDevice?: boolean;
}

const KSelectDevice = ({
  name,
  company = "",
  label,
  value,
  placeholder = "",
  helperText = "",
  error = false,
  errorText = "",
  disabled = false,
  onChange,
  style = {},
  canRemoveDevice = false,
}: Props) => {
  const [{ open }, setState] = useSetState({
    open: false,
  });

  const toggleOpen = () => setState({ open: !open });

  const handleSubmit = (e, v) => onChange(e, v);

  const handleSelectDevice = (e, row) => {
    handleSubmit(e, row.imei);
    toggleOpen();
  };

  const clearImei = { imei: "" };

  const devicePopup = (
    <KDialog
      size="md"
      title="Select Device"
      open={open}
      onClose={toggleOpen}
      secondaryCTAColor="secondary"
      secondaryCTAonClick={toggleOpen}
      secondaryCTAText="Cancel"
      primaryCTAText="Remove Current Device"
      primaryCTAColor="danger"
      primaryCTAonClick={
        value && canRemoveDevice
          ? (e) => handleSelectDevice(e, clearImei)
          : undefined
      }
    >
      <DevicesTable
        withCTA={false}
        handleSelectDevice={handleSelectDevice}
        company={company}
      />
    </KDialog>
  );

  return (
    <>
      <KTextInput
        endIcon="box"
        name={name}
        label={label}
        helperText={helperText}
        disabled={disabled}
        onChange={() => {}}
        style={style}
        placeholder={placeholder}
        value={value}
        onClick={toggleOpen}
        error={error}
        errorText={errorText}
      />
      {devicePopup}
    </>
  );
};

export default KSelectDevice;
